export default function GamePotionHint({ hint }) {
  if (!hint) return null;

  if (hint.type === "remede") {
    return (
      <p className="game-qcm-potion-hint">
        Le mot à trouver commence par la lettre{" "}
        <strong className="game-qcm-potion-hint__letter">{hint.firstLetter}</strong>.
      </p>
    );
  }

  if (hint.type === "philtre") {
    return (
      <p className="game-qcm-potion-hint">
        Le mot à trouver commence par la lettre{" "}
        <strong className="game-qcm-potion-hint__letter">{hint.firstLetter}</strong> et finit
        par la lettre{" "}
        <strong className="game-qcm-potion-hint__letter">{hint.lastLetter}</strong>.
      </p>
    );
  }

  if (hint.type === "elixir") {
    return (
      <p className="game-qcm-potion-hint game-qcm-potion-hint--elixir">
        <span className="game-qcm-potion-hint__elixir-pattern">{hint.pattern}</span>
      </p>
    );
  }

  if (hint.type === "decouverte") {
    return (
      <p className="game-qcm-potion-hint game-qcm-potion-hint--decouverte">
        Potion de découverte : un mot encore jamais joué apparaît !
      </p>
    );
  }

  if (hint.type === "mixture-3eme-oeil") {
    return (
      <p className="game-qcm-potion-hint game-qcm-potion-hint--mixture">
        Mixture du 3ème œil : un mot joué exactement 2 fois apparaît !
      </p>
    );
  }

  if (hint.type === "grog-veuve-noire") {
    return (
      <p className="game-qcm-potion-hint game-qcm-potion-hint--grog">
        Grog de la veuve noire : un mot gradé inférieur à B+ apparaît !
      </p>
    );
  }

  if (hint.type === "mixture-du-brucolaque") {
    return (
      <p className="game-qcm-potion-hint game-qcm-potion-hint--brucolaque">
        Mixture du brucolaque : un mot moins récemment joué apparaît !
      </p>
    );
  }

  if (hint.type === "bouillon-deja-vu") {
    return (
      <p className="game-qcm-potion-hint game-qcm-potion-hint--bouillon">
        Bouillon de Déjà-vu : un mot joué exactement 1 fois apparaît !
      </p>
    );
  }

  if (hint.type === "serum-cadran") {
    return (
      <p className="game-qcm-potion-hint game-qcm-potion-hint--serum">
        Sérum du Cadran : +25 secondes pour répondre (50 s au total pour cette question).
      </p>
    );
  }

  if (hint.type === "baume-sursis") {
    return (
      <p className="game-qcm-potion-hint game-qcm-potion-hint--sursis">
        Baume du Sursis : cette question est reportée en fin de partie !
      </p>
    );
  }

  return null;
}
